import {zxcvbnOptions} from '@zxcvbn-ts/core'
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common'
import {dictionary as dictionaryDe} from '@zxcvbn-ts/language-de'
import {translations as translationsEn, dictionary as dictionaryEn} from '@zxcvbn-ts/language-en'
import translationDe from './zxcvbn/de'

export default defineNuxtPlugin(() => {
    const {locale} = useNuxtApp().$i18n

    const switchLocale = (locale: string) => {
        if (locale === 'en') {
            zxcvbnOptions.setOptions({
                translations: translationsEn,
                dictionary: {
                    ...zxcvbnCommonPackage.dictionary,
                    ...dictionaryEn,
                },
            })
        }
        if (locale === 'de') {
            zxcvbnOptions.setOptions({
                translations: translationDe,
                dictionary: {
                    ...zxcvbnCommonPackage.dictionary,
                    ...dictionaryDe,
                },
            })
        }
    }

    switchLocale(locale.value)

    return {
        provide: {
            switchZxcvbnLocale: switchLocale
        }
    }
})

declare module '#app' {
    interface NuxtApp {
        $switchZxcvbnLocale: (locale: string) => void;
    }
}
